export default [
  {label: 'EN', locale: 'en'},
  {label: '中文', locale: 'zh'},
]
